import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=43dde94b&scoped=true&"
import script from "./Profile.vue?vue&type=script&setup=true&lang=js&"
export * from "./Profile.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&id=43dde94b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dde94b",
  null
  
)

export default component.exports